/**
 * @title ordersummary-cart.js: Feature level module
 * @description The sub module used for the order summary widget on shopping cart
 * @dependency orderitems
 */
define(['orderitems'], function(orderitems) {
  let OrderSummaryCart = {
		  
	firstMeasurementGuideValidation: false,
	
    init: function() {
       if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
         COSTCO.util.makeElementSticky("order-summary-column", "cart-title", "sticky-ends");
         COSTCO.util.triggerClickOnEnterKeyPress('#shipping-costs-zip', '#shipping-costs-calc');
       }
       
       $(window).on('beforeunload', function(){
    	   COSTCO.OrderItems.saveMeasurementGuidesCheckboxesStates();
   	   
       });
       
       $(window).on('load', function() {
    	   let doesMeasurementGuidesChexboxExsts = ($('input[id^="measuring-guides-checkbox-"]').length > 0) ? true : false;  
    	   if (doesMeasurementGuidesChexboxExsts) {
    		   COSTCO.OrderItems.populateMeasurementGuidesCheckboxes();
    	   }   	   
    	   OrderSummaryCart.measurementGuideCheckboxesOnOff();
    	   
       });
    },
    
    
    measurementGuideCheckboxesOnOff: function() {
 	   $('input[id^="measuring-guides-checkbox-"]').on('click', function() {
		   if (OrderSummaryCart.firstMeasurementGuideValidation) {
    		   if (!$(this).is(":checked")) {
    			   COSTCO.OrderItems.highlightMeasuringError(this);
    		   } else {
    			   COSTCO.OrderItems.unhighlightMeasuringError(this);
    		   }
		   }
		   COSTCO.OrderItems.saveMeasurementGuidesCheckboxesStates();
	   });
    },
    
    /**
     * Submits shipping cart form
     */
    submitCart: function(action) {
    	
    /*If there is a quantity error, remain on the page and do not proceed with checkout.
     $("span[id^='quantity_']")[0] will be undefined when there are no quantity errors on BC and will have class=unit for average weight items on BD
     $("label[for^='quantity_']")[0] will be undefined when there are no quantity errors on BD*/
      if (($("span[id^='quantity_']")[0] != undefined && $("span[id^='quantity_']")[0].getAttribute('class') != 'unit') || $("label[for^='quantity_']")[0] != undefined){
       return;
      }

    //do not allow checkout if a not sold separately item from a bundle is without associated bundle items
    	if(undefined != $('.notSoldBundil').val() && null != $('.notSoldBundil').val())  {

    		var bundleId = $(".notSoldBundil").val();	
    		var itemsInBundle = $("[id^='notSoldSeperatelyBundleId_'][value="+bundleId+"]");
    		var itemsNotSoldSep = 0;
    		const orderItemIdsInBundle = [];

    		$.each(itemsInBundle, function(index, value){
    			orderItemIdsInBundle.push(value.id.slice(26));
    		});

    		$.each(orderItemIdsInBundle, function (index, value){
    			if($('#notSoldSeperatelyItem_' + value).val() == 'true'){  				
    				itemsNotSoldSep++;
    			}		
    		});

    		if (itemsInBundle.length - itemsNotSoldSep == 0){
    			$.each(orderItemIdsInBundle, function (index, value){
    				if($('#notSoldSeperatelyItem_' + value).val() == 'true'){				
    					$('#notSoldSepLineItemError-' + value).removeClass('hide');
    					$('#notSoldSepLineItemError-' + value).focus();
    					window.digitalDataEvents = window.digitalDataEvents || [];
    					digitalDataEvents.push( {uimsg:"Checkout Flow | Error | Item cannot be sold separately remove to continue"} );
        			}
    			});
    			return;
    		}
    	}
      
      document.ShopCartForm.action = action;
      
      var currentZipCode = $('#bdZipCookie').val();
      if (currentZipCode !== undefined && currentZipCode !== false && currentZipCode.length == 0) {
    	  return;
      }
      
      let isLocalSelected = $('#deldatepicker').parents('label[name="delivery-options-radio"]').children('input').is(':checked');
      let isPickupSelected;
      
      if (COSTCO.util.isNdEnabled()) {
          isLocalSelected = $('#deldatepicker').parents('div[class="radio-fieldset-nd-rebranding selection-box-v3 local-delivery"]').children('input').is(':checked')
          isPickupSelected = $('#deldatepicker').parents('div[class="radio-fieldset-nd-rebranding selection-box-v3 store-Pick-Up"]').children('input').is(':checked')
      }
      
      if($('#order-level-delivery-options').length > 0 &&
		 $('#deldatepicker').length > 0 && (isLocalSelected || isPickupSelected)) {
    	  if(COSTCO.OrderSummary.validateDate()) {
    		  COSTCO.OrderItems.validate(COSTCO.OrderItems.submit_cart);
    	  }
      } else if ($('.measuring-guides-warning').length > 0) {
    	  COSTCO.OrderItems.saveMeasurementGuidesCheckboxesStates();
    	  if (COSTCO.OrderItems.validateMeasurementGuidesEligibility()) {
    		  COSTCO.OrderItems.validate(COSTCO.OrderItems.submit_cart);
    	  } else {
    		  OrderSummaryCart.firstMeasurementGuideValidation = true;
    	  }
      } else {
    	  COSTCO.OrderItems.validate(COSTCO.OrderItems.submit_cart);
      }
      
    }

  }; // end OrderSummaryCart object

  // Expose OrderSummaryCart to the global scope.
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = new Object();
  }

  window.COSTCO.OrderSummaryCart = OrderSummaryCart;
  return OrderSummaryCart;
});



// WEBPACK FOOTER //
// ./js/checkout/ordersummary-cart.js